import { render, staticRenderFns } from "./VendorPopUp.vue?vue&type=template&id=44ad80c4"
import script from "./VendorPopUp.vue?vue&type=script&lang=js"
export * from "./VendorPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports